import React, { FC, Fragment } from 'react';
import { faCheck, faInfo, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IncludeInfo } from '../../ts/interfaces/OphirResponse';
import { useTranslation } from 'react-i18next';

interface OphirIncludeCardProps {
  include: IncludeInfo;
}

const OphirIncludeCard: FC<OphirIncludeCardProps> = ({ include }) => {
  const [t] = useTranslation() as unknown as [(key: string) => string];
  return (
    <Fragment>
      {!!(
        include.includeInformation.length ||
        include.notIncludeNames.length ||
        include.includeNames.length ||
        include.cancelInformation.length
      ) && (
          <div id='oph-include'>
            <div className="title">{t('tour.what_included')}</div>
            <div className="default-shadow mb-20">
              {!!include.includeNames.length && (
                <div className="include-wr">
                  <span className="title">{t('tour.included')}</span>
                  {include.includeNames.map((item, index) => (
                    <div className="include item" key={index}>
                      <FontAwesomeIcon icon={faCheck as any} />
                      {item}
                    </div>
                  ))}
                </div>
              )}

              {!!include.notIncludeNames.length && (
                <div className="include-wr">
                  <span className="title">{t('tour.not_included')}</span>
                  {include.notIncludeNames.map((item, index) => (
                    <div className="no-include item" key={index}>
                      <FontAwesomeIcon icon={faXmark as any} />
                      {item}
                    </div>
                  ))}
                </div>
              )}
              {!!include.includeInformation.length && (
                <div className="include-wr">
                  <span className="title">{t('tour.additional_info')}</span>
                  {include.includeInformation.map((item, index) => (
                    <div className="info item" key={index}>
                      <FontAwesomeIcon icon={faInfo as any} />
                      {item}
                    </div>
                  ))}
                </div>
              )}

              {!!include.cancelInformation.length && (
                <div className="include-wr">
                  <span className="title">{t('tour.cancel_information')}</span>
                  {include.cancelInformation.map((item, index) => (
                    <div className="item no-include" key={index}>
                      <FontAwesomeIcon icon={faInfo as any} />
                      {item}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
    </Fragment>
  );
};

export default OphirIncludeCard;
